import React, {useEffect, useState} from "react";
import "./OnlineSwiper.scss";
import SwiperId from "react-id-swiper";
import {useHistory} from "react-router-dom";
import {useBasket, useDispatchBasket} from "../../hooks";
import {BasketAddRemove} from "..";
import "./ribbon.scss";


const imageParamss = {
    slidesPerView: 'auto',
    spaceBetween: 20,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
}


function numberWithCommas  (x) {
    if (x === 0) {
        return 0
    }
    if(x){
        x= Math.round(x)
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}


function OnlineSwiper({list,merchantId,title="",more=null}) {

    //hooks
    const history = useHistory();
    const setBasket = useDispatchBasket();
    console.log(list)

    useEffect(()=>{
        //get storage count
        let local_basket = localStorage.getItem('basket');
        if(local_basket){
            setBasket(JSON.parse(local_basket))
        }else {
            setBasket([])
        }
    },[])

    return(
            // <span>swiper ...</span>
        <div className="online-swiper-cont" style={{backgroundColor:"white"}}>
            <div className="online-swiper-header">
                <div className="online-swiper-more" onClick={()=>{
                    if(more){
                        history.push(`/online-store-sub-categories/${merchantId}/${more}`)
                    }
                }}>
                    <i className="fa fa-angle-left"></i>
                    <span>بیشتر</span>
                </div>
                <span className="online-swiper-title">{title}</span>
            </div>
                {list && list.length>0? <SwiperId {...imageParamss}>
                    {list.map(item=>{
                        return(
                            <div style={{width:100}}>
                                <div className="swiper-card-container">
                                    <div className="swiper-card-body" >
                                        <BasketAddRemove item={item}/>
                                        <div onClick={()=>{
                                            history.push(`/online-store-product/${merchantId}/${item.uid}`)
                                        }}>
                                            <img src={item.image} alt=""/>
                                        </div>
                                    </div>
                                    <div className="price-section">
                                        <div className="price">
                                            {numberWithCommas(item.price)} ریال
                                        </div>
                                        {item.price_original-item.price>0?<div className="price-without-off">
                                            {numberWithCommas(item.price_original)}
                                        </div>:null}
                                    </div>
                                    {item && item.discount_percentage!==0?
                                        <div className="off">
                                            <span>{item.discount_percentage+" % "}</span>
                                        </div>:null
                                    }

                                    <div className="info-section">
                                        <div className="name">{item.name}</div>
                                        {/*<div className="weight">1500 گرمی میهن</div>*/}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </SwiperId>:null}
                </div>
    )
}

export {OnlineSwiper};
